import * as types from "./mutation-type";
import { getAlertsQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";


const actions = {
  async getAlerts({ commit }, variables = {}) {
    try {
      commit(types.GET_ALERTS_BEGIN);
      const {
        data: {
          data: {
            company: { alerts }
          }
        }
      } = await gqlClient.query({
        query     : getAlertsQuery,
        variables : variables
      });
      
      commit(types.GET_ALERTS_SUCCESS, alerts);
    } catch (e) {
      commit(types.GET_ALERTS_ERROR, e);
    }
  },
  async deleteAlert({ commit }, id) {
    commit(types.DELETE_ALERT_BEGIN);
    try {
      await api.alert.deleteAlert(id);
      commit(types.DELETE_ALERT_SUCCESS, id);

    } catch (e) {
      commit(types.DELETE_ALERT_ERROR, e);
    }
  },
  async createAlert({ commit }, variables ) {
    try {
      commit(types.CREATE_ALERT_BEGIN)
      
      const { data  }  = await api.alert.addAlert(variables)
      commit(types.CREATE_ALERT_SUCCESS,data)

    } catch (e) {
      commit(types.CREATE_ALERT_ERROR, e)
    }
  },
  async updateAlert({ commit }, { id, data }){
    commit(types.UPDATE_ALERT_BEGIN)
    try {
      const { data : updatedData } = await api.alert.update(id,data)
      commit(types.UPDATE_ALERT_SUCCESS, updatedData)

    } catch (error) {
      commit(types.UPDATE_ALERT_ERROR, error)
    }
  },
};

export default actions;
